/**
 * One-time and magic link tokens (t173). New links carry the token in the URL #fragment, which browsers never send to a
 * server (so it can't land in web, gateway or auth access logs, or in a Referer header). Older links put it in the path
 * or query string; those keep working until they expire.
 */
const TOKEN = /^[A-Za-z0-9_-]{8,}$/;

/** Driver magic link: /run#<token> (new) or /run/<token> (older). */
export function runLinkToken(pathname: string, hash: string): string | null {
  const path = /^\/run\/([A-Za-z0-9_-]+)\/?$/.exec(pathname);
  if (path) return path[1];
  if (/^\/run\/?$/.test(pathname)) { const t = hash.replace(/^#/, ''); return TOKEN.test(t) ? t : null; }
  return null;
}

/** Emailed Supabase link params: #token_hash=…&type=… (new) or ?token_hash=…&type=… (older). */
export function emailLinkToken(hash: string, search: string, expected: 'recovery' | 'invite'): { token: string; email: string | null } | null {
  const h = new URLSearchParams(hash.replace(/^#/, ''));
  const qs = h.get('token_hash') ? h : new URLSearchParams(search);
  const token = qs.get('token_hash'), type = qs.get('type');
  return token && type === expected ? { token, email: qs.get('email') } : null;
}
